var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalculators(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 267 267",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.3,128.9h128.6V0.3H0.3V128.9z M37,55.4h18.4V37c0-5.1,4.1-9.2,9.2-9.2c5.1,0,9.2,4.1,9.2,9.2v18.4h18.4 c5.1,0,9.2,4.1,9.2,9.2c0,5.1-4.1,9.2-9.2,9.2H73.8v18.4c0,5.1-4.1,9.2-9.2,9.2c-5.1,0-9.2-4.1-9.2-9.2V73.8H37 c-5.1,0-9.2-4.1-9.2-9.2C27.8,59.5,32,55.4,37,55.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.1,0.3v128.6h128.6V0.3H138.1z M230,73.8h-55.1c-5.1,0-9.2-4.1-9.2-9.2c0-5.1,4.1-9.2,9.2-9.2H230 c5.1,0,9.2,4.1,9.2,9.2C239.2,69.7,235,73.8,230,73.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.1,266.7h128.6V138.1H138.1V266.7z M174.8,179.4H230c5.1,0,9.2,4.1,9.2,9.2s-4.1,9.2-9.2,9.2h-55.1 c-5.1,0-9.2-4.1-9.2-9.2S169.8,179.4,174.8,179.4z M174.8,207H230c5.1,0,9.2,4.1,9.2,9.2c0,5.1-4.1,9.2-9.2,9.2h-55.1 c-5.1,0-9.2-4.1-9.2-9.2C165.7,211.1,169.8,207,174.8,207z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.3,266.7h128.6V138.1H0.3V266.7z M35.1,185.9c-3.6-3.6-3.6-9.4,0-13c3.6-3.6,9.4-3.6,13,0l16.5,16.5 l16.5-16.5c3.6-3.6,9.4-3.6,13,0c3.6,3.6,3.6,9.4,0,13l-16.5,16.5l16.5,16.5c3.6,3.6,3.6,9.4,0,13c-1.8,1.8-4.1,2.7-6.5,2.7 s-4.7-0.9-6.5-2.7l-16.5-16.5l-16.5,16.5c-1.8,1.8-4.1,2.7-6.5,2.7s-4.7-0.9-6.5-2.7c-3.6-3.6-3.6-9.4,0-13l16.5-16.5L35.1,185.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalculators);
export default __webpack_public_path__ + "static/media/icon-calculators.245b23c637a3eb223c4aadbe8763d126.svg";
export { ForwardRef as ReactComponent };